import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'

// Configure dayjs once, here, so the plugins are guaranteed to be applied before
// any consumer runs (ES modules evaluate this dependency before the importer's body).
// Import dayjs from this module — not from 'dayjs' directly — anywhere these plugins
// are relied on:
//   - customParseFormat: parsing with an explicit format / array of formats, strict mode
//   - advancedFormat:    extra format tokens such as `Do` ordinals
//   - localeData:        dayjs.monthsShort() and friends
dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(localeData)

export default dayjs
